import { getField, updateField } from "vuex-map-fields";
import db from "@/firebase/firebaseInit";

const state = {
    allPositiveResults: [],
    allNegativeResults: [],
};

const actions = {
    async fetchAllContact({ commit }) {

        await db.collection('/contact_tracing').get().then(
            (snapshot) => {
                var allPositiveResults = [];
                var allNegativeResults = [];
                snapshot.forEach(doc => {
                    const data = doc.data();
                    if (data.test_result === "Positive"){
                        allPositiveResults.push(doc.id);
                    }
                    if (data.test_result === "Negative"){
                        allNegativeResults.push(doc.id);
                    }

                });
                commit("updateField", {
                    path: "allPositiveResults",
                    value: allPositiveResults,
                })
                commit("updateField", {
                    path: "allNegativeResults",
                    value: allNegativeResults,
                })

            });
    },

    async updateContact({ commit }, payload) {

        await db.collection('/contact_tracing').get().then(
            (snapshot) => {
                snapshot.forEach(async doc => {
                    if (doc.id === payload.id) {
                        await db.collection('/contact_tracing').doc(doc.id).update({test_result: payload.state})

                    }
                });

            });
    },
};

const mutations = {
    updateField,
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
